
import {defineComponent} from 'vue';

import RuiInput from '@/retinus-ui/components/input/RuiInput.vue';
import RuiDynamicInput from '@/retinus-ui/components/dynamic-Input/RuiDynamicInput.vue';
import RuiButton from '@/retinus-ui/components/button/RuiButton.vue';
import RuiListFlat from '@/retinus-ui/components/list-flat/RuiListFlat.vue';

import {BUTTON_TEXT, PLACEHOLDER_TEXT} from '../../../core/constants';

export default defineComponent({
  name: 'fire-support-form',
  props: {
    disableSubmit: Boolean,
    descriptionValue: String,
    subjectValue: String,
  },
  components: {
    RuiInput,
    RuiDynamicInput,
    RuiButton,
    RuiListFlat,
  },
  data() {
    return {
      buttonText: BUTTON_TEXT,
      placeholderText: PLACEHOLDER_TEXT,
    };
  },
});
